<!-- <div class="messages-container">
  <mat-card class="messages-card">
     <mat-card-header>
  <mat-toolbar-row>
    <button mat-icon-button (click)="goBack()" title="Back to Conversations" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="title-spacer"></span>
    <mat-card-title>Conversation with {{ conversationId }}</mat-card-title>
  </mat-toolbar-row>
</mat-card-header>

    <mat-card-content>
      <div class="chat-container">
        <div *ngFor="let message of messages$ | async" class="message-group">
          <div class="message-date">{{ message.updatedAt | date:'medium' }}</div>
          <div *ngIf="message.summary" class="summary">Summary: {{ message.summary }}</div>
          <div *ngFor="let item of message.messages" class="message-bubble" [ngClass]="{'user': item.role === 'user','human': (item.role === 'assistant')&&(item.human), 'assistant': item.role === 'assistant' && !item.tool_calls}">
            <div *ngIf="item.role!=='tool' && !item.tool_calls">
                 <div class="message-content" [innerHTML]="sanitizeHtml(item.content)"></div>

                 <div class="message-role"> <span *ngIf="item.human">Human </span>{{ item.role }}<span *ngIf="item.email"> | {{item.email}}</span> <span *ngIf="item.createdAt"> | {{item.createdAt| date:'medium'}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <mat-spinner *ngIf="!(messages$ | async)" diameter="50"></mat-spinner>

       




      <mat-tab-group [(selectedIndex)]="selectedTabIndex" *ngIf="send_msgs">
      <mat-tab label="Template Message">
        <div class="template-composer">
          
      <div class="template-composer">
        <mat-form-field appearance="outline" class="template-select">
          <mat-label>Select Template</mat-label>
            <mat-select [(ngModel)]="selectedTemplate" (selectionChange)="onTemplateChange($event.value)">
            <mat-option *ngFor="let tpl of templates" [value]="tpl">{{ tpl.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="selectedTemplate" class="template-inputs">
          <div *ngFor="let variable of selectedTemplate.variables" class="template-input">
            <mat-form-field appearance="outline" class="variable-field">
              <mat-label>{{ variable }}</mat-label>
              <input matInput [(ngModel)]="templateValues[variable]" placeholder="Enter {{ variable }}">
            </mat-form-field>
          </div>

          <div class="template-preview">
            <mat-card>
              <mat-card-subtitle>Preview</mat-card-subtitle>
              <mat-card-content>
                {{ getPreviewMessage() }}
              </mat-card-content>
            </mat-card>
          </div>

          <button mat-raised-button color="primary" [disabled]="isLoading" (click)="sendTemplateMessage()">
            <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
            <span *ngIf="!isLoading">Send Message</span>
          </button>
        </div>
      </div>

        </div>
      </mat-tab>
      <mat-tab label="Free-form Message">
        <div class="freeform-composer">
          
      <div class="freeform-composer ">
      
        <mat-card class="button-padding">
          <mat-card-header>
            <mat-card-title>Send Message (Within 24hrs after customer message)</mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <mat-form-field appearance="outline" class="freeform-field">
              <mat-label>Enter your message</mat-label>
              <textarea
                matInput
                rows="4"
                [(ngModel)]="freeformMessage"
                placeholder="Type your message here">
              </textarea>
            </mat-form-field>
          </mat-card-content>

          <mat-card-actions class="action-row">
            <mat-slide-toggle
              color="warn"
              [checked]="humanAgent"
              (change)="onToggleHumanAgent($event)">
              Disable AI Agent Response
            </mat-slide-toggle>

            <button mat-raised-button color="accent" [disabled]="isSendingFreeform" (click)="sendMessage()">
              <mat-spinner *ngIf="isSendingFreeform" diameter="24"></mat-spinner>
              <span *ngIf="!isSendingFreeform">Send Message</span>
            </button>
          </mat-card-actions>
        </mat-card>

      </div>
        </div>
      </mat-tab>
    </mat-tab-group>


    </mat-card-content>
  </mat-card>
</div>

 -->

 <div class="messages-container">
  <mat-card class="messages-card">
    <mat-card-header>
      <mat-toolbar-row>
        <button mat-icon-button (click)="goBack()" title="Back to Conversations" class="back-button">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="title-spacer"></span>
        <mat-card-title>Conversation with {{ conversationId }}</mat-card-title>
      </mat-toolbar-row>
    </mat-card-header>

    <mat-card-content>

      <!-- Date tabs -->
      <ng-container *ngIf="!loadingMessages; else loadingState">
        <mat-tab-group
          *ngIf="dateGroups.length; else emptyState"
          class="date-tabs"
          [(selectedIndex)]="selectedDateIndex"
          animationDuration="200ms">
          <mat-tab *ngFor="let message of dateGroups" [label]="message.updatedAt | date:'MMM d'">
            <div class="chat-container">
              <div class="message-group">
                <div *ngIf="message.summary" class="summary">Summary: {{ message.summary }}</div>
                <div
                  *ngFor="let item of message.messages"
                  class="message-bubble"
                  [ngClass]="{'user': item.role === 'user','human': (item.role === 'assistant')&&(item.human), 'assistant': item.role === 'assistant' && !item.tool_calls}">
                  <div *ngIf="item.role!=='tool' && !item.tool_calls">
                    <div class="message-content" [innerHTML]="sanitizeHtml(item.content)"></div>
                    <div class="message-role">
                      <span *ngIf="item.human">Human </span>{{ item.role }}<span *ngIf="item.email"> | {{item.email}}</span> <span *ngIf="item.createdAt"> | {{item.createdAt| date:'medium'}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

        <ng-template #emptyState>
          <div class="empty-state">No conversation history yet.</div>
        </ng-template>
      </ng-container>

      <ng-template #loadingState>
        <mat-spinner diameter="50"></mat-spinner>
      </ng-template>

      <!-- Message composer -->
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" *ngIf="send_msgs" class="composer-tabs">
        <mat-tab label="Template Message">
          <div class="template-composer">
            <mat-form-field appearance="outline" class="template-select">
              <mat-label>Select Template</mat-label>
              <mat-select [(ngModel)]="selectedTemplate" (selectionChange)="onTemplateChange($event.value)">
                <mat-option *ngFor="let tpl of templates" [value]="tpl">{{ tpl.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="selectedTemplate" class="template-inputs">
              <div *ngFor="let variable of selectedTemplate.variables" class="template-input">
                <mat-form-field appearance="outline" class="variable-field">
                  <mat-label>{{ variable }}</mat-label>
                  <input matInput [(ngModel)]="templateValues[variable]" placeholder="Enter {{ variable }}">
                </mat-form-field>
              </div>

              <div class="template-preview">
                <mat-card>
                  <mat-card-subtitle>Preview</mat-card-subtitle>
                  <mat-card-content>
                    {{ getPreviewMessage() }}
                  </mat-card-content>
                </mat-card>
              </div>

              <button mat-raised-button class="send-btn" [disabled]="isLoading" (click)="sendTemplateMessage()">
                <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
                <span *ngIf="!isLoading">Send Message</span>
              </button>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Free-form Message">
          <div class="freeform-composer">
            <mat-card class="button-padding">
              <mat-card-header>
                <mat-card-title>Send Message (Within 24hrs after customer message)</mat-card-title>
              </mat-card-header>

              <mat-card-content>
                <mat-form-field appearance="outline" class="freeform-field">
                  <mat-label>Enter your message</mat-label>
                  <textarea
                    matInput
                    rows="4"
                    [(ngModel)]="freeformMessage"
                    placeholder="Type your message here">
                  </textarea>
                </mat-form-field>
              </mat-card-content>

              <mat-card-actions class="action-row">
                <mat-slide-toggle
                  color="warn"
                  [checked]="humanAgent"
                  (change)="onToggleHumanAgent($event)">
                  Disable AI Agent Response
                </mat-slide-toggle>

                <button mat-raised-button class="send-btn" [disabled]="isSendingFreeform" (click)="sendMessage()">
                  <mat-spinner *ngIf="isSendingFreeform" diameter="24"></mat-spinner>
                  <span *ngIf="!isSendingFreeform">Send Message</span>
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        </mat-tab>
      </mat-tab-group>

    </mat-card-content>
  </mat-card>
</div>
